import isEmpty from 'lodash/isEmpty';
import unescape from 'lodash/unescape';
import React, {useState} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {DESTINATION_DATA} from 'destination/destination-prop-types';
import {compose} from 'redux';
import {connect} from 'react-redux';
import moment from 'moment';
import IconTimes from '@spothero/icons/times';
import Button from '@spothero/ui/button';
import Image from 'common/image/Image';
import withConfig from 'config/withConfig';
import {toggleInfoPanelView} from 'search/search-actions';

const DestinationInfoPanel = ({
    isMonthly,
    city: {
        display_name: cityTitle,
        default_image: {id: cityImgId},
        city,
        state,
        description,
        monthly_description: monthlyDescription,
    },
    destination,
    event,
    displayEventDateFormat,
    onHideInfoPanelClick,
}) => {
    const [isClosing, setIsClosing] = useState(false);
    const classes = classNames('DestinationInfoPanel', {
        'DestinationInfoPanel-closing': isClosing,
    });
    const onCloseClick = () => {
        setIsClosing(true);

        setTimeout(() => {
            onHideInfoPanelClick();
        }, 250); // 250 is animation time of the fade out
    };
    let title = cityTitle;
    let imgId = cityImgId;
    let imgAlt = title;
    let displayTitle = `${unescape(title)} ${
        isMonthly ? 'Monthly ' : ''
    }Parking Information`;
    let displayDescription =
        isMonthly && monthlyDescription ? monthlyDescription : description;
    let address = null;
    let eventStartsFormatted = null;

    if (!isEmpty(destination)) {
        const {
            title: destinationTitle,
            default_image: defaultImage,
            street_address: destinationAddress,
            description: destinationDescription,
            monthly_description: monthlyDestinationDescription,
            destination_info_title: infoPanelTitle,
            monthly_destination_info_title: monthlyInfoPanelTitle,
        } = destination;

        title = destinationTitle;
        imgId = defaultImage ? defaultImage.object.public_id : null;
        imgAlt = defaultImage ? defaultImage.object.alt_text : null;
        displayTitle = `${
            !isEmpty(event.eventTitle) ? event.eventTitle : destinationTitle
        } ${isMonthly ? 'Monthly ' : ''}Parking Information`;
        displayDescription = !isEmpty(event.eventCustomDescription)
            ? event.eventCustomDescription
            : isMonthly && monthlyDestinationDescription
            ? monthlyDestinationDescription
            : destinationDescription;
        address = destinationAddress;
        eventStartsFormatted = event.starts
            ? moment(event.starts).format(displayEventDateFormat)
            : null;

        if (isMonthly && !isEmpty(monthlyInfoPanelTitle)) {
            displayTitle = monthlyInfoPanelTitle;
        } else if (!isEmpty(infoPanelTitle)) {
            displayTitle = infoPanelTitle;
        }
    }

    return (
        <div className={classes}>
            <Button
                className="DestinationInfoPanel-hide"
                color="secondary"
                onClick={onCloseClick}
            >
                <IconTimes />
            </Button>
            <div className="DestinationInfoPanel-container">
                {imgId && (
                    <Image
                        className="DestinationInfoPanel-image"
                        width={300}
                        height={200}
                        cloudinaryImageId={imgId}
                        alt={imgAlt}
                    />
                )}
                <div className="DestinationInfoPanel-title">
                    <h2>{displayTitle}</h2>
                </div>
                <div className="DestinationInfoPanel-content">
                    <h2>
                        {address && <span>{unescape(address)} </span>}
                        {city && <span>{city}</span>}
                        {state && <span>, {state}</span>}
                    </h2>
                    {eventStartsFormatted && <h2>{eventStartsFormatted}</h2>}
                    <div
                        dangerouslySetInnerHTML={{__html: displayDescription}}
                    />
                </div>
            </div>
        </div>
    );
};

DestinationInfoPanel.propTypes = {
    displayEventDateFormat: PropTypes.string.isRequired,
    isMonthly: PropTypes.bool.isRequired,
    city: PropTypes.object.isRequired,
    destination: PropTypes.shape(DESTINATION_DATA),
    event: PropTypes.object,
    onHideInfoPanelClick: PropTypes.func.isRequired,
};

const mapStateToProps = ({
    city: {data: city},
    destination: {data: destination},
    event: {data: event},
    searchRequest: {monthly: isMonthly},
}) => {
    return {
        isMonthly,
        city,
        destination,
        event,
    };
};

const mapDispatchToProps = {
    onHideInfoPanelClick: toggleInfoPanelView,
};

const enhance = compose(
    withConfig(['displayEventDateFormat']),
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
);

export default enhance(DestinationInfoPanel);
